import "./productionForecast.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import { IRRADIANCEDATA } from "../../../Features/irrediance";
import { inverterInformation } from "../../DataFiles/inverterInformation"
import { kiloToMegaWatt } from "./projectOverview";

function statsRender(title, vals, labels) {
  let percantages = perCal(vals[0], vals[1]);

  let circumference = 40 * 2 * Math.PI;
  let strokeLength = [
    (circumference * percantages[0]) / 100,
    (circumference * percantages[1]) / 100,
  ];

  let sym1 = "kWh";
  let val1 = vals[0];
  if (vals[0] >= 1000) {
    sym1 = "MWh";
    val1 = (vals[0] / 1000).toFixed(2);
  }
  let sym2 = "kWh";
  let val2 = vals[1];
  if (vals[1] >= 1000) {
    sym2 = "MWh";
    val2 = (vals[1] / 1000).toFixed(2);
  }

  return (
    <div className="stats-function">
      <p>{title}</p>
      <div className="stats">
        <div className="stats-text">
          <span className="number">{val1}</span>{" "}
          <span className="normal">
            {" "}
            {sym1} {labels[0]}
          </span>
          <br />
          <span className="percentage">({percantages[0]}%)</span>
        </div>
        <div className="chart">
          <svg
            style={{ overflow: "visible", position: "absolute" }}
            width="100px"
            height="100px"
          >
            <circle
              style={{
                transform: "rotate(0deg)",
                transformOrigin: "center",
              }}
              className=""
              cx={50}
              cy={50}
              r={40}
              fill="none"
              stroke="#045097"
              strokeWidth={9.5}
              strokeLinecap="round"
              strokeDasharray={`0,12.5,${
                strokeLength[0] - 15
              },${circumference}`}
            />
            <circle
              style={{
                transform: "rotate(0deg)",
                transformOrigin: "center",
              }}
              className=""
              cx={50}
              cy={50}
              r={40}
              fill="none"
              stroke="#A0D4F5"
              strokeWidth={10}
              strokeLinecap="round"
              strokeDasharray={`0,${strokeLength[0] + 10},${strokeLength[1]}`}
            />
          </svg>
          <div className="svg-text">
            <span className="top">{vals[2].toFixed(2)}</span>
            <br />
            <span>{vals[3]}</span>
          </div>
        </div>
        <div className="stats-text">
          <span className="number" style={{ color: "#A0D4F5" }}>
            {val2}
          </span>{" "}
          <span className="normal">
            {sym2} {labels[1]}
          </span>
          <br />
          <span className="percentage">({percantages[1]}%)</span>
        </div>
      </div>
    </div>
  );
}

function statsRenderTwo(title, vals, labels, alert) {
  let percantages = perCal(vals[0], vals[1]);

  let circumference = 40 * 2 * Math.PI;
  let strokeLength = [
    (circumference * percantages[0]) / 100,
    (circumference * percantages[1]) / 100,
  ];

  let sym1 = "kW";
  let val1 = vals[0];
  if (vals[0] >= 1000) {
    sym1 = "MW";
    val1 = (vals[0] / 1000).toFixed(2);
  }
  let sym2 = "kW";
  let val2 = vals[1];
  if (vals[1] >= 1000) {
    sym2 = "MW";
    val2 = (vals[1] / 1000).toFixed(2);
  }

  return (
    <div className="stats-function">
      <p>{title} <span>{alert}</span></p>
      <div className="stats">
        <div className="stats-text">
          <span className="number">{val1}</span>{" "}
          <span className="normal">
            {" "}
            {sym1} {labels[0]}
          </span>
        </div>
        <div className="chart">
          <svg
            style={{ overflow: "visible", position: "absolute" }}
            width="100px"
            height="100px"
          >
            <circle
              style={{
                transform: "rotate(0deg)",
                transformOrigin: "center",
              }}
              className=""
              cx={50}
              cy={50}
              r={40}
              fill="none"
              stroke="#045097"
              strokeWidth={9.5}
              strokeLinecap="round"
              strokeDasharray={`0,12.5,${
                strokeLength[0] - 15
              },${circumference}`}
            />
            <circle
              style={{
                transform: "rotate(0deg)",
                transformOrigin: "center",
              }}
              className=""
              cx={50}
              cy={50}
              r={40}
              fill="none"
              stroke="#A0D4F5"
              strokeWidth={10}
              strokeLinecap="round"
              strokeDasharray={`0,${strokeLength[0] + 10},${strokeLength[1]}`}
            />
          </svg>
          <div className="svg-text">
            <span className="top">{vals[2].toFixed(2)}</span>
            <br />
            <span>{vals[3]}</span>
          </div>
        </div>
        <div className="stats-text">
          <span className="number" style={{ color: "#A0D4F5" }}>
            {val2}
          </span>{" "}
          <span className="normal">
            {sym2} {labels[1]}
          </span>
        </div>
      </div>
    </div>
  );
}

function tableRender(tableData) {
  return (
    <div className="render-function">
      <table className="render-table">
        <thead>
          <tr>
            <td>Property</td>
            <td>Value</td>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => {
            return (
              <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                <td className="left">{item.title}</td>
                <td className="right">{item.value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function perCal(one, two) {
  let total1 = one + two;
  return [((100 * one) / total1).toFixed(2), ((100 * two) / total1).toFixed(2)];
}

const ProductionForecast = (props) => {
  const { tableContent, roofDetail, index } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Production Forecast"
  );
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const check = quantityInfo.allRoof;
  let inverterInfo = [];

  const irradianceCity = roofInfo?.value?.nearestWeatherStation
    ? roofInfo.value.nearestWeatherStation
    : "Lahore";
  const irradiance =
    irradianceCity === "Select Weather Station"
      ? IRRADIANCEDATA["Lahore"]
      : IRRADIANCEDATA[irradianceCity];
  let totalCapacity = 0;

  let month = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  let exportEnergy = 0;
  let importEnergy = 0;
  let yeild = 0;

  if (check && quantityInfo.electricalConfiguration === "All Roof") {
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      if (element.structureType === "Single") {
        totalCapacity += Number(element.totalKilowatt);
      } else {
        const totalKilowatt = Number(
          element.multipleStructure
            .reduce((total, data) => total + data.totalKilowatt, 0)
            .toFixed(1)
        );
        totalCapacity += Number(totalKilowatt);
      }
    }
    for (let j = 0; j < 12; j++) {
      let value = 0;
      for (let i = 0; i < roofData.length; i++) {
        value += roofData[i].actualGeneration[j];
      }
      yeild += value;
      value -= roofInfo.value.financialAnalysis[month[j]];
      if (value >= 0) {
        exportEnergy += value;
      } else {
        importEnergy += -value;
      }
    }
  } else {
    if (roofDetail.structureType === "Single") {
      totalCapacity = Number(roofDetail.totalKilowatt);
    } else {
      const totalKilowatt = Number(
        roofDetail.multipleStructure
          .reduce((total, data) => total + data.totalKilowatt, 0)
          .toFixed(1)
      );
      totalCapacity = Number(totalKilowatt);
    }
    for (let j = 0; j < 12; j++) {
      let value = roofDetail.actualGeneration[j];
      yeild += value;
      value -= roofInfo.value.financialAnalysis[month[j]];
      if (value >= 0) {
        exportEnergy += value;
      } else {
        importEnergy += -value;
      }
    }
  }

  if (quantityInfo.electricalConfiguration === "All Roof") {
    inverterInfo = roofInfo.value.inverterAnalysis;
  } else {
    inverterInfo = roofDetail.inverterAnalysis;
  }

  totalCapacity = Number(totalCapacity.toFixed(1));

  const tcyValue = roofInfo?.value?.financialAnalysis?.tcy
    ? roofInfo.value.financialAnalysis.tcy
    : null;

  let irradianceSum = Object.values(irradiance).reduce(
    (sum, value) => sum + value,
    0
  );

  let inverterBrand = inverterInformation.find(
    (item) =>
      item.brand === inverterInfo.inverterManufacturer &&
      item.phase === inverterInfo.inverterPhase &&
      item.systemType === inverterInfo.systemType
  );

  let inverterDetail =
    inverterInfo.inverterType !== "Select"
      ? inverterBrand.inverterType.find(
          (item) => item.name === inverterInfo.inverterType
        )
      : [];
  const inverterACCapacity = inverterDetail.name;
  const ACValue = inverterDetail.value;

  let pvYeild = yeild / totalCapacity;

  const performancRatio = (1 - pvYeild / irradianceSum) * 100;

  let moduleConfiguration = [
    {
      title: "DC generated Output",
      value: `${kiloToMegaWatt(totalCapacity)}p`,
    },
    {
      title: "Inverter AC capacity",
      value: inverterACCapacity ? inverterACCapacity : "Select",
    },
    {
      title: "Specific PV Yeild",
      value: `${Number(pvYeild.toFixed(1)).toLocaleString("en-US")} kWh/kWp`,
    },
    {
      title: "PV generated energy",
      value: `${kiloToMegaWatt(Number(yeild.toFixed(1)))}h`,
    },
    {
      title: "Performance ratio",
      value: `${performancRatio.toFixed(1)} %`,
    },
    {
      title: "Building self consumption",
      value: `${kiloToMegaWatt(tcyValue)}h`,
    },
    {
      title: "Export to grid",
      value: `${kiloToMegaWatt(Number(exportEnergy.toFixed(1)))}h`,
    },
    {
      title: "Import from grid",
      value: `${kiloToMegaWatt(Number(importEnergy.toFixed(1)))}h`,
    },
  ];

  const firstGraph = [
    Number(exportEnergy.toFixed(2)),
    Number(importEnergy.toFixed(2)),
  ];
  const maxValue = Math.max(...firstGraph);
  let sym3 = "kWh";
  let val3 = maxValue.toFixed(2);
  if (val3 >= 1000) {
    sym3 = "MWh";
    val3 = (val3 / 1000).toFixed(2);
  }

  const title = check
    ? quantityInfo.electricalConfiguration === "All Roof"
      ? `Production Forecast (All Roof)`
      : `Production Forecast (Roof ${index + 1})`
    : `Production Forecast`;

    let alert = ""
    if(inverterInfo.inverterType === "Select"){
      if(quantityInfo.electricalConfiguration === "All Roof"){
        alert = "*Required all roof configuration"
      }else{
        alert = "*Required single roof configuration"
      }
    }

  return (
    <div id="production-forecast" className="production-forecast">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header/>
      {/* Main Body */}
      <main className="pf-body">
        <p>{title} </p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(moduleConfiguration)}
        </div>
        {/* 1. Production, import and export */}
        {statsRender(
          "1. Production, Import and Export",
          [
            Number(exportEnergy.toFixed(2)),
            Number(importEnergy.toFixed(2)),
            Number(val3),
            sym3,
          ],
          ["Export Energy", "Import Energy"]
        )}
        {/* 2. Dc to AC ratio graph */}
        {statsRenderTwo(
          "2. DC to AC ratio graph",
          [
            Number(ACValue * inverterInfo.noOfInverter),
            Number(totalCapacity),
            Number(totalCapacity) /
              (Number(ACValue) * inverterInfo.noOfInverter),
            "%",
          ],
          ["AC Power", "DC Power"], alert
        )}
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default ProductionForecast;
